export enum QuarantineStatusCodes {
  THREAT_STATUS_SPAM = 0,
  THREAT_STATUS_SUSPECTED = 1,
  THREAT_STATUS_INFECTED = 2,
  THREAT_STATUS_ATTACHMENT_DETECTION = 3,
  THREAT_STATUS_CONTENT_DETECTION = 4,
  THREAT_STATUS_UNSCANNABLE = 5,
}

export const ExchangeprotectionStatusCodesToName = {
  [QuarantineStatusCodes.THREAT_STATUS_SPAM]: 'Spam',
  [QuarantineStatusCodes.THREAT_STATUS_SUSPECTED]: 'Suspect',
  [QuarantineStatusCodes.THREAT_STATUS_INFECTED]: 'Infected',
  [QuarantineStatusCodes.THREAT_STATUS_ATTACHMENT_DETECTION]: 'Attachment Detection',
  [QuarantineStatusCodes.THREAT_STATUS_CONTENT_DETECTION]: 'Content Detection',
  [QuarantineStatusCodes.THREAT_STATUS_UNSCANNABLE]: 'Unscannable',
};

export const statusCodesFilterValues = Object.entries(ExchangeprotectionStatusCodesToName).map(([value, label]) => ({
  value: Number(value),
  label,
}));

export function convertIntToThreatsStatus(value) {
  switch (value) {
    case QuarantineStatusCodes.THREAT_STATUS_INFECTED:
      return 'Infected';
    case QuarantineStatusCodes.THREAT_STATUS_SPAM:
      return 'Spam';
    case QuarantineStatusCodes.THREAT_STATUS_SUSPECTED:
      return 'Suspect';
    case QuarantineStatusCodes.THREAT_STATUS_UNSCANNABLE:
      return 'Unscannable';
    case QuarantineStatusCodes.THREAT_STATUS_ATTACHMENT_DETECTION:
      return 'Attachment detection';
    case QuarantineStatusCodes.THREAT_STATUS_CONTENT_DETECTION:
      return 'Content detection';
    default:
      return '';
  }
}
